import { gql, useMutation, useQuery } from "@apollo/client";
import Button from "components/base/Button";
import Errors from "components/base/Errors";
import { InlineSpinner } from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { useModals } from "ModalProvider";
import ChooseImagesFromOneDriveView from "./images/ChooseImagesFromOneDriveView";

const FETCH_PRODUCT_LINE_IMAGES = gql`
  query FETCH_PRODUCT_LINE_IMAGES($id: ID!) {
    productLine(id: $id) {
      id
      slug
      images: newImages(stage: "wis") {
        id
        url(size: "300x300")
      }
    }
  }
`;

const SYNC_PRODUCT_LINE_WIS_IMAGES = gql`
  mutation SYNC_PRODUCT_LINE_WIS_IMAGES($slug: String!, $ids: [String]!) {
    syncWisProductLineImagesFromOneDrive(slug: $slug, ids: $ids) {
      productLine {
        id
        images: newImages(stage: "wis") {
          id
          url(size: "300x300")
        }
      }
    }
  }
`;

const ProductLineImages = ({ id }) => {
  const { loading, error, data } = useQuery(FETCH_PRODUCT_LINE_IMAGES, {
    variables: { id },
  });

  const [syncProductLineWisImages, syncProductLineWisImagesRes] = useMutation(
    SYNC_PRODUCT_LINE_WIS_IMAGES,
    {
      onCompleted() {
        Alert("success", "Images synced.");
      },
      onError(error) {
        Alert("error", error.message);
      },
    },
  );

  const modal = useModals();

  function chooseImages() {
    modal.present({
      title: "Choose Images",
      subtitle: "From One Drive",
      fullscreen: true,
      children: <ChooseImagesFromOneDriveView onSave={saveImages} />,
    });
  }

  function saveImages(selectedImages) {
    modal.hide();
    syncProductLineWisImages({
      variables: {
        slug: data.productLine.slug,
        ids: selectedImages.map((i) => i.id),
      },
    });
  }

  if (loading) return <InlineSpinner text={null} size={21} />;
  if (error) return <Errors error={error} />;

  return (
    <div>
      {data.productLine.images.length === 0 ? (
        <div className="mb-2 opacity-70">
          This product line does not have any images.
        </div>
      ) : (
        <div className="flex flex-wrap">
          {data.productLine.images.map((i) => (
            <img className="mr-2 mb-2 w-20" key={i.id} src={i.url} />
          ))}
        </div>
      )}

      <div>
        <Button
          className="mt-2"
          onClick={chooseImages}
          loading={syncProductLineWisImagesRes.loading}
        >
          Choose Images from One Drive
        </Button>
      </div>
    </div>
  );
};

const ProductLineImagesView = ({ id }) => {
  return (
    <div className="card px-6 py-4">
      <h4>Images</h4>

      <div className="mt-4">
        {id ? (
          <ProductLineImages id={id} />
        ) : (
          <div className="opacity-70">
            Create a product line before adding images.
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductLineImagesView;
